const BASE_URL = "https://www.actnowbutton.com";
const BASE_URL_SETTINGS = "https://www.actnowbutton.com/settings";
const BASE_URL_HOMEPAGE_SUCCESS =
  "https://www.actnowbutton.com/gotPremium=true";

export { BASE_URL, BASE_URL_SETTINGS, BASE_URL_HOMEPAGE_SUCCESS };
